/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualOtherOpexDto } from '../../models/backend-actual-other-opex-dto';
import { BackendPatchedActualOtherOpexRequestDto } from '../../models/backend-patched-actual-other-opex-request-dto';

export interface MonitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedActualOtherOpexRequestDto;
}

export function monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualOtherOpexDto>;
    }),
  );
}

monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded.PATH = '/api/monitoring/actuals/other-opexes/{id}/';
